export enum AppearanceType {
  AGO_Haze1 = "AGO_Haze1",
  AGO_Haze2 = "AGO_Haze2",
  AGO_Haze3 = "AGO_Haze3",
  AGO_Haze4 = "AGO_Haze4",
  PMS_ClearAndBright = "PMS_ClearAndBright",
  PMS_NotClearAndBright = "PMS_NotClearAndBright",
  RMS_ClearAndBright = "RMS_ClearAndBright",
  RMS_NotClearAndBright = "RMS_NotClearAndBright",
  LFO_Black = "LFO_Black",
  LFO_NotBlack = "LFO_NotBlack",
  JETA1_ClearAndBright = "JETA1_ClearAndBright",
  JETA1_NotClearAndBright = "JETA1_NotClearAndBright",
}
